import { actions as layoutActions } from 'components/page/Layout';
import { GONE, NOT_FOUND } from 'http-status';
import { getSeoSearchUrl } from 'helpers/namedUrls';
import { initModule } from 'helpers/initRoute';
import { push as pushRoute } from 'connected-react-router';
import { cmsDuck } from './duck';
import {
  getCmsTemplate,
  getCmsRedirect,
  getCurrentCmsTemplate,
} from './selectors';
import getTemplateComponent, { MAIN_SEARCH } from './getTemplateComponent';

const getHttpError = ({ statusCode, result }) => ({
  statusCode,
  result,
});

export const initCmsModule = ({ match, withFetchAction } = {}) =>
  function* ({ getState }) {
    const cmsTemplate = getCmsTemplate(getState());
    const module = getTemplateComponent(cmsTemplate);

    if (module) {
      yield cmsDuck.set({ currentTemplate: cmsTemplate });

      yield initModule({
        match,
        module,
        withFetchAction,
      });
    } else {
      const error = getHttpError({
        statusCode: NOT_FOUND,
        result: `There is no a component for '${cmsTemplate}' cms template`,
      });

      yield cmsDuck.set({ error });

      throw error;
    }
  };

export const fetch = (match) =>
  function* ({ setServerResponseStatus, getState }) {
    const {
      params: { route },
    } = match;

    try {
      const currentTemplate = getCurrentCmsTemplate(getState());

      if (currentTemplate === MAIN_SEARCH) {
        yield initCmsModule({ match, withFetchAction: true });
      } else {
        yield cmsDuck.load(route);

        const redirectUrl = getCmsRedirect(getState());

        if (redirectUrl) {
          return yield pushRoute({ pathname: getSeoSearchUrl(redirectUrl) });
        }

        yield initCmsModule({ match, withFetchAction: true });
      }
    } catch (error) {
      const { statusCode } = error;

      if (statusCode) {
        if (statusCode === GONE) {
          const httpError = getHttpError({
            statusCode: GONE,
            result: error.error.message,
          });

          yield cmsDuck.set({ error: httpError });

          setServerResponseStatus(statusCode);

          return yield initCmsModule({ match, withFetchAction: true });
        }

        yield layoutActions.fetch();

        setServerResponseStatus(statusCode);
      } else {
        throw error;
      }
    }
  };
